import React, {useCallback, useEffect, useRef} from 'react';
import {SteppedEase, TweenMax} from "gsap";
import {useSelector} from "react-redux";

const ScrollIcon = (props) => {

    const carats = useRef();

    const panelData = useSelector(state => state.panelData);

    useEffect(()=>{

        setTimeout(()=>{

            if(carats.current){

                let signatureDuration = 1.5;

                let height = 1840;
                TweenMax.to(carats.current,signatureDuration,{
                        backgroundPosition: `0 -${height}px`,ease:SteppedEase.config(46),
                        repeat:-1,
                        repeatDelay: 1
                    });

                /** hard set at end of animation for resizers **/
                setTimeout(()=>{
                    if(carats.current) carats.current.style.backgroundPosition= 'center bottom';
                },signatureDuration + 200)

            }


        }, 0);

    }, [])

    const getStyle = useCallback(()=>{
        let newSrc = 'https://msobd-storage.azureedge.net/images/scrollIcon.png';
        if(panelData.stackOrder.cache === 'active' || panelData.stackOrder.martellus === 'active'){
            newSrc = 'https://msobd-storage.azureedge.net/images/scrollIcon-grey.png'
        }
        return {
            backgroundImage: `url(${newSrc})`,
            width: '20px',
            height: '40px'
        };
    }, [panelData])


    return (
        <div ref={carats} style={getStyle()}/>
    )
};

export default ScrollIcon
